module.exports = __webpack_public_path__ + "media/svg/cbs-news-271215e6.svg";